import { useCallback } from 'react';
import { createGlobalState, useLocalStorage } from 'react-use';

import { UncontrolledCheckbox } from '@dreryk/react-components';

import { visitHistoryTranslationKeys } from '../../translations';

import { StyledVisitHistoryShowAnnulledCheckbox } from './VisitHistoryShowAnnulledCheckbox.styled';

const ANNULLED_PRESCRIPTIONS_VISIBILITY_PREFERENCE_KEY = 'annulledPrescriptionsVisibilityPreference';

const useAnnulledVisitsVisibilityPreferenceGlobalState = createGlobalState<boolean>(
   window.localStorage.getItem(ANNULLED_PRESCRIPTIONS_VISIBILITY_PREFERENCE_KEY) === 'true'
);

export const VisitHistoryShowAnnulledCheckbox = (): JSX.Element => {
   const [preferAnnulledPrescriptionsVisible, setAnnulledVisitsVisibilityPreference] = useLocalStorage<boolean>(
      ANNULLED_PRESCRIPTIONS_VISIBILITY_PREFERENCE_KEY,
      false
   );
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   const [_, setAnnulledVisitsVisibilityGlobalState] = useAnnulledVisitsVisibilityPreferenceGlobalState();
   const handleAnnulledVisitsVisibilityChange = useCallback(
      (visible: boolean) => {
         setAnnulledVisitsVisibilityPreference(visible);
         setAnnulledVisitsVisibilityGlobalState(visible);
      },
      [setAnnulledVisitsVisibilityGlobalState, setAnnulledVisitsVisibilityPreference]
   );
   return (
      <StyledVisitHistoryShowAnnulledCheckbox>
         <UncontrolledCheckbox
            testId={'annulledVisitsVisibility'}
            name={'annulledVisitsVisibility'}
            id={'annulledVisitsVisibility'}
            label={visitHistoryTranslationKeys.annulledVisible}
            selected={Boolean(preferAnnulledPrescriptionsVisible)}
            onSelectionChange={handleAnnulledVisitsVisibilityChange}
         />
      </StyledVisitHistoryShowAnnulledCheckbox>
   );
};
VisitHistoryShowAnnulledCheckbox.useAnnulledVisitsVisibilityPreferenceGlobalState = useAnnulledVisitsVisibilityPreferenceGlobalState;
